import { initializeDB } from '../config/db';
import { GAS_MONITOR_TEST_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

const gasMonitorTestService = {
    /**
     * Submit gas monitor test to server
     */
    async submit(test) {
        try {
            const response = await axiosInstance.post('/gas-monitor-test/submit', test);
            return response.data;
        } catch (error) {
            console.error('Error submitting gas monitor test:', error);
            throw error;
        }
    },

    /**
     * Save gas monitor test as draft in IndexedDB
     */
    async saveDraft(test) {
        const db = await initializeDB();
        const now = new Date().toISOString();

        const testToSave = {
            ...test,
            updatedAt: now
        };

        if (!testToSave.status) {
            testToSave.status = 'draft';
        }

        if (!testToSave.createdAt) {
            testToSave.createdAt = now;
        }

        await db.put(GAS_MONITOR_TEST_STORE, testToSave);
        return testToSave;
    },

    /**
     * Load gas monitor test by UUID from IndexedDB
     */
    async loadByUuid(uuid) {
        const db = await initializeDB();
        return await db.get(GAS_MONITOR_TEST_STORE, uuid);
    },

    /**
     * Get all gas monitor tests from IndexedDB
     */
    async getAll() {
        const db = await initializeDB();
        return await db.getAll(GAS_MONITOR_TEST_STORE);
    },

    /**
     * Delete gas monitor test from IndexedDB
     */
    async delete(uuid) {
        const db = await initializeDB();
        await db.delete(GAS_MONITOR_TEST_STORE, uuid);
    }
};

export default gasMonitorTestService;
